export const AddExisting = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_169_24430)">
        <path
          d="M6.00551 0H2.08301C1.75149 0 1.43354 0.131696 1.19912 0.366116C0.964704 0.600537 0.833008 0.918479 0.833008 1.25V10H9.16634V3.16083L6.00551 0ZM6.24967 1.4225L7.74384 2.91667H6.24967V1.4225ZM1.66634 9.16667V1.25C1.66634 1.13949 1.71024 1.03351 1.78838 0.955372C1.86652 0.877232 1.9725 0.833333 2.08301 0.833333H5.41634V3.75H8.33301V9.16667H1.66634ZM5.41634 5.83333H6.66634V6.66667H5.41634V7.91667H4.58301V6.66667H3.33301V5.83333H4.58301V4.58333H5.41634V5.83333Z"
          fill="#41395C"
        />
      </g>
      <defs>
        <clipPath id="clip0_169_24430">
          <rect width="10" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
